import React from 'react';
import { Link } from '@americanexpress/dls-react';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { getEmail } from '../../redux/selectors';
import FormattedRichMessage from '../common/FormattedRichMessages';
import PrivacyFlowLayout from './PrivacyFlowLayout';
import TaiwanContactTable from './TaiwanContactTable';
import styles from './styles/ConfirmPage.scss';
import commonStyles from './styles/PrivacyFlow.scss';
import { isTaiwanMarketPathname } from '../../utils/ModuleMap';
const ConfirmPage = () => {
  const email = useSelector(getEmail);
  const intl = useIntl();
  const activeLocale = intl.locale.toLowerCase();
  return /*#__PURE__*/React.createElement(PrivacyFlowLayout, null, intl.messages['confirm.thankyou'] && /*#__PURE__*/React.createElement("h1", {
    className: commonStyles.title
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "confirm.thankyou"
  })), intl.messages['confirm.title'] && /*#__PURE__*/React.createElement("h1", {
    className: `${commonStyles.title} ${styles.confirmTitle}`
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "confirm.title"
  })), /*#__PURE__*/React.createElement("p", {
    className: commonStyles.text
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "confirm.successMessage",
    values: {
      email: /*#__PURE__*/React.createElement("span", {
        className: styles.emailBlue
      }, email)
    }
  })), intl.messages['confirm.timelineMessage'] && /*#__PURE__*/React.createElement("p", {
    className: commonStyles.text
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "confirm.timelineMessage"
  })), isTaiwanMarketPathname(activeLocale) && /*#__PURE__*/React.createElement(TaiwanContactTable, {
    intl: intl
  }), intl.messages['confirm.additionalAction'] && /*#__PURE__*/React.createElement("p", {
    className: commonStyles.text
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "confirm.additionalAction"
  })), intl.messages['confirm.returnHome'] && /*#__PURE__*/React.createElement("div", {
    className: styles.returnHomeWrapper
  }, /*#__PURE__*/React.createElement(Link, {
    href: `https://www.americanexpress.com/${activeLocale}/`,
    "aria-label": intl.formatMessage({
      id: 'confirm.returnHome'
    })
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "confirm.returnHome"
  }))));
};
export default ConfirmPage;